var _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEllipse59(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 860,
    height: 1068,
    viewBox: "0 0 860 1068",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 600,
    cy: 468,
    r: 600,
    fill: "url(#paint0_linear_637_28397)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_28397",
    x1: 1234.53,
    y1: -424.625,
    x2: -30.2114,
    y2: -424.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D12D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D12D6",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse59);
export default __webpack_public_path__ + "static/media/Ellipse59.e048725fb9d3eb18724c0a46b893c23e.svg";
export { ForwardRef as ReactComponent };